import { Injectable, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { QueryParams } from 'src/app/types';

@Injectable({
  providedIn: 'root'
})
export class QueryParamsService {
  public qParams = signal<QueryParams>({});

  queryParams: any = {};
  queryParamsChange = new BehaviorSubject(this.queryParams);

  queryParamsChangeType = new BehaviorSubject(null);
  currentSharedQueryParamsChangeType = this.queryParamsChangeType.asObservable();
  
  queryParamsFilterKeyType = new BehaviorSubject(null);
  currentSharedQueryParamsFilterKeyType = this.queryParamsFilterKeyType.asObservable();

  sharedNavigationChangedState = new BehaviorSubject<any>(null);
  currentSharedNavigationChangedState = this.sharedNavigationChangedState.asObservable();

  updateSharedNavigationChangedState(sharedNavigatoionChangedState: any) {
    this.sharedNavigationChangedState.next(sharedNavigatoionChangedState);
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParams = JSON.parse(JSON.stringify(params));
      Object.keys(this.queryParams).forEach((key) => {
        if (!(this.queryParams[key] instanceof Array)) {
          this.queryParams[key] = [this.queryParams[key]]
        }
      });
      const parsedParams = this.parseQueryParams(params);
      this.qParams.set(parsedParams);
      this.queryParamsChange.next(this.queryParams);
    });
  }

  private parseQueryParams(params: any): QueryParams {
    const queryParams = { ...params };
    Object.keys(queryParams).forEach((key) => {
      if (!(queryParams[key] instanceof Array)) {
        queryParams[key] = [queryParams[key]];
      }
    });
    return queryParams;
  }

  setQueryParamsChangeType(type: any) {
    this.queryParamsChangeType.next(type)
  }

  setQueryParamsFilterKeyType(type: any) {
    this.queryParamsFilterKeyType.next(type)
  }

  routeForInput(input: any, route: string) {
    return this.router.navigate([route], {
      queryParamsHandling: "merge",
      relativeTo: this.activatedRoute,
      queryParams: input,
    })
  }

  setUniqueValueForKey(input: any, route: string) {
    if (!input['pageIndex'] && Object.keys(input).length > 0) {
      input['pageIndex'] = 0;
    }
    if ((input['pageIndex'] || input['pageIndex'] === 0) && input['pageSize']) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { pageIndex: input['pageIndex'], pageSize: input['pageSize'] }
      });
    }
    return this.routeForInput(input, route);
  }

  clearFilters() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {},
    })
  }
}
